module.exports = __webpack_public_path__ + "6efe99543894807db763dfdf5328697f.jpg";